import { SESSIONSTATUS_FAIL, SESSIONSTATUS_SUCCESS } from '../actionTypes';

const initialState = {
    user: null
};

const sessionStatusReducer = (state = initialState, action) => {
    switch (action.type) {
        case SESSIONSTATUS_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case SESSIONSTATUS_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default sessionStatusReducer;
